module.exports = __webpack_public_path__ + "img/logo-linkedin.14f7b675.svg";